import { Autocomplete, Stack, TextField, Typography } from "@mui/material";
import { ColorsConstants } from "../../../../cssUtils/constants";

// Only one-tap templates (created with a WhatsApp Form button) can be sent by this
// node: the submitted form comes back to the bot that sent the template.
const hasFormButton = (template) => {
  const preview = template?.template_preview_json || {};
  if (!preview.formButtonOneTap) return false;

  let buttons = preview.allButtons;
  if (typeof buttons === "string") {
    try {
      buttons = JSON.parse(buttons);
    } catch (e) {
      return false;
    }
  }

  return (
    Array.isArray(buttons) &&
    buttons.some((button) => button?.type === "whatsapp-form")
  );
};

const TemplateFormMessagePreset = ({ config, handleConfigChange, templates }) => {
  const formTemplates = (templates || []).filter(hasFormButton);

  return (
    <Stack spacing={3}>
      <Autocomplete
        options={formTemplates}
        value={
          formTemplates.find(
            (template) => template?.template_id === config["template_id"],
          ) || null
        }
        onChange={(e, newValue) =>
          handleConfigChange("template_id", newValue?.template_id || "")
        }
        renderInput={(params) => (
          <TextField
            {...params}
            label="Select Template"
            variant="outlined"
            required
            helperText="Only approved templates with a WhatsApp Form button are listed."
          />
        )}
        getOptionLabel={(option) => option?.template_name || ""}
        renderOption={(props, option) => (
          <Stack
            {...props}
            key={option?.id}
            direction="column"
            gap={0.5}
            sx={{
              alignItems: "flex-start !important",
              textAlign: "left",
              width: "100%",
            }}
          >
            <Typography>{option?.template_name}</Typography>
            <Typography variant="body2" color={ColorsConstants.primaryGray40}>
              {option?.category?.[0]}
              {option?.category?.slice(1).toLowerCase()}
            </Typography>
          </Stack>
        )}
        isOptionEqualToValue={(option, value) =>
          option?.template_id === value?.template_id
        }
        noOptionsText="No templates with a WhatsApp Form button found"
      />
    </Stack>
  );
};

export default TemplateFormMessagePreset;
